import { Box, Group } from '@mantine/core';
import { MessageAttachment } from '../chat/types';
import { UploadingChatFile } from '../chats/types';
import { ChatFileCard } from './ChatFileCard';

export function ChatFileCardRow({
  files,
  uploadingFiles = [],
  onRemove,
}: {
  files: MessageAttachment[];
  uploadingFiles?: UploadingChatFile[];
  onRemove?: (index: number) => void;
}) {
  if (files.length === 0 && uploadingFiles.length === 0) return null;

  return (
    <Box style={{ overflowX: 'auto' }}>
      <Group gap="sm" wrap="nowrap" align="stretch">
        {files.map((file, index) => (
          <ChatFileCard
            key={`${file.filename}-${index}`}
            file={file}
            onRemove={onRemove ? () => onRemove(index) : undefined}
          />
        ))}
        {uploadingFiles.map(file => (
          <ChatFileCard key={file.id} file={file} isUploading />
        ))}
      </Group>
    </Box>
  );
}
